import PropTypes from "prop-types";
import GuidedSearchText from "../../../../../features/browse-search/components/GuidedSearchText";
import BaseSearchPage from "../../../SearchPage";

export const SearchPage = ({ formatTranslation, location }) => (
  <BaseSearchPage
    formatTranslation={formatTranslation}
    location={location}
    topContent={<GuidedSearchText />}
  />
);

SearchPage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  location: PropTypes.object,
};

export default SearchPage;
